import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { alterarSenha, auth, logout } from '../../../contexts/authentication';
import { UserData, getUser } from '../../../frontend/pages/getUserDB';
import WarningAlert from '../WarningAlert';
import { updateProfile } from 'firebase/auth';
import { validatePassword } from '../../pages/profile/validationUserDates';
import PasswordInput from '../PasswordInput';
import { Typography } from '@mui/material';

interface Props {
  showPasswordModal: boolean;
  setShowPasswordModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowAlertWithDone: React.Dispatch<React.SetStateAction<boolean>>;
  setMessageAlert: React.Dispatch<React.SetStateAction<string>>
}

export default function ChangePassword({
  showPasswordModal,
  setShowPasswordModal,
  setShowAlertWithDone,
  setMessageAlert
}: Props) {
  const currentUser = auth.currentUser;
  const [userDB, setUserDB] = useState<UserData>();
  const [showWarningAlert, setShowWarningAlert] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [newPwd, setNewPwd] = useState('');
  const [repeatNewPwd, setRepeatNewPwd] = useState('');
  const [passwordValidations, setPasswordValidations] = useState({
    hasUpperCase: false,
    hasLowerCase: false,
    hasNumber: false,
    isLengthValid: false,
  });

  const navigate = useNavigate();


  useEffect(() => {
    const dataUser = async () => {
      const data = await getUser();
      setUserDB(data);
    }
    dataUser();
  }, []);

  useEffect(() => {
    if (showWarningAlert) {
      setTimeout(() => {
        setShowWarningAlert(false)
      }, 6000)
    }
  }, [showWarningAlert]);


  const handlePwdClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (newPwd !== repeatNewPwd) {
      setShowWarningAlert(true);
      setWarningMessage("Senhas não conferem!");
      return;
    }

    const { validations, errorMessage } = validatePassword(newPwd);
    setPasswordValidations(validations);

    if (errorMessage) {
      setShowWarningAlert(true);
      setWarningMessage(errorMessage);
      return;
    }

    alterarSenha(newPwd);
    setMessageAlert("Senha alterada com sucesso! Faça o login com a nova senha.");
    setShowAlertWithDone(true);
    // logout();
    // navigate('/signin');
    setShowPasswordModal(false);
  }

  return (
    <Dialog
      open={showPasswordModal}
      onClose={() => setShowPasswordModal(false)}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: (e: React.MouseEvent<HTMLButtonElement>) => {
            handlePwdClick(e);
          },
          sx: { backgroundImage: 'none', width: '100%' },
        },
      }}
    >
      <DialogTitle>Alterar senha</DialogTitle>
      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
      >
        <DialogContentText>
          A senha deve conter de 6 a 10 caracteres, letra maiúscula, minúscula, e número.
        </DialogContentText>
        <Box
          sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}
        >
          <Typography>
            Digite sua nova senha:
          </Typography>
          <PasswordInput
            password={newPwd}
            setPassword={setNewPwd}
          />
          <Typography>
            Repita sua nova senha:
          </Typography>
          <PasswordInput
            password={repeatNewPwd}
            setPassword={setRepeatNewPwd}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button onClick={() => setShowPasswordModal(false)}>Cancelar</Button>
        <Button variant="contained" type="submit">
          Continuar
        </Button>
      </DialogActions>
      {showWarningAlert && (
        <WarningAlert
          message={warningMessage}
        />
      )}
    </Dialog>
  );
}